"use strict";

define(['app'], function (app) {
  return app.Backbone.Model.extend({
    defaults: {
      type: 'image',
      source_thumb: false,
      source: false,
      bbcode_url: false,
      file_original_name: '',
      file_size: -1,
      file_uuid: ''
    },
    isLoaded: function isLoaded() {
      return !!this.get('source_thumb') || this.get('file_size') >= 0;
    },
    initialize: function initialize() {
      this.set('__id', app._.uniqueId('attachment_'));
    }
  });
});